import { Component, Input, OnInit } from '@angular/core';
import { Color } from '../../../constants/color.constants';

@Component({
    selector: 'no-data',
    styleUrls: ['./no-data.component.scss'],
    template: `
        <div class="no-data">
            <div>
                <lsq-icon
                    [style.marginBottom]="'1rem'"
                    [type]="icon"
                    [color]="colors.MidGray"
                    [height]="50"
                ></lsq-icon>
                <p class="label" [style.marginBottom]="'0.5rem'">{{ titleText }}</p>
                <p>{{ description }}</p>
            </div>
        </div>
    `
})
export class NoDataComponent {
    @Input() public icon: string;
    @Input() public titleText: string;
    @Input() public description: string;

    public colors = Color;
}
